import React from "react";
import "./SurfExplanation.css"; // CSS file for styling

import { Button } from "../../Components/Button/Button";

import SurfPuerto from "../../images/surf_puerto.jpg";
import { useNavigate } from "react-router-dom";

export const SurfExplanation = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/activities");
  };

  return (
    <section className="surf-section">
      <div className="surf-section__image">
        <img src={SurfPuerto} alt="Surf in Puerto Escondido" />
      </div>
      <div className="surf-section__content">
        <h2 className="surf-section__title">Surf</h2>
        <p className="surf-section__description">
          Si alguna vez soñaste con conquistar las olas, Puerto Escondido es el
          lugar perfecto para hacerlo realidad. Con sus playas icónicas, aguas
          cálidas y olas para todos los niveles todo el año, este paraíso es
          conocido como el <strong>Mex Pipe.</strong>
          <br /> <br />
          En TIDE, te llevamos paso a paso en esta aventura, con instructores
          expertos, equipo de primera y un ambiente seguro. No importa si es tu
          primera vez, en solo una sesión sentirás la emoción de montar tu
          primera ola.
          <br />
          <br />
          📍 Clases personalizadas
          <br />
          📍 Instructores certificados
          <br />
          📍 Equipamiento de alta calidad
          <br />
          <br />
          Atrévete a vivir la experiencia. Reserva tu clase hoy y conquista las
          olas con nosotros.
          <br />
          <br />
          Contáctanos ahora y da el primer paso hacia una nueva pasión.
        </p>
        <Button
          type="primary"
          onClick={handleRedirect}
          text="Reserva tu clase"
        />
      </div>
    </section>
  );
};
